import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  z-index: 10;
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral_700};
  opacity: 0.6;
`;

export const Content = styled.div`
  position: absolute;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.neutral_100};
  cursor: default;
  max-width: 92vw;
  max-height: 86vh;
  overflow: overlay;
`;

export const Icon = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  cursor: pointer;
  background-color: transparent;

  &:hover {
    background-color: ${({ theme }) => theme.neutral_200};
  }

  svg {
    color: ${({ theme }) => theme.neutral_700};
    width: 100%;
    height: 100%;
  }
`;
